<template>
  <el-dialog :close-on-click-modal="false" title="充电枪详情" :visible="detailFormVisible" :modal-append-to-body='false' @close="closeDetailForm">
    <el-tabs v-model="viewName">
      <el-tab-pane label="详情" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="基本信息" name="basicInformation">
              <el-col :span="12">
                <el-form-item label="充电枪编号：" :label-width="formLabelWidth" prop="gunCode">
                  <label v-text="detailForm.gunCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="充电枪口号：" :label-width="formLabelWidth" prop="gunNum">
                  <label v-text="detailForm.gunNum"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="充电枪名称：" :label-width="formLabelWidth" prop="gunName">
                  <label v-text="detailForm.gunName"></label>
                </el-form-item>
              </el-col>

<!--              <el-col :span="12">-->
<!--                <el-form-item label="是否支持预约：" :label-width="formLabelWidth" prop="ableAppointment">-->
<!--                  <label v-text="detailForm.ableAppointment"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <el-form-item label="预约订单号：" :label-width="formLabelWidth" prop="appointmentId">-->
<!--                  <label v-text="detailForm.appointmentId"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="12">
                <el-form-item label="是否锁住：" :label-width="formLabelWidth" prop="gunLock">
                  <label v-if="detailForm.gunLock" v-text="detailForm.gunLock.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="登录IP：" :label-width="formLabelWidth" prop="commandIp">
                  <label v-text="detailForm.commandIp"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="登录端口：" :label-width="formLabelWidth" prop="commandPort">
                  <label v-text="detailForm.commandPort"></label>
                </el-form-item>
              </el-col>
<!--              <el-col :span="12">-->
<!--                <el-form-item label="备注：" :label-width="formLabelWidth" prop="remark">-->
<!--                  <label v-text="detailForm.remark"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
            </el-collapse-item>
            <el-collapse-item title="绑定信息" name="bindingInformation">
              <el-col :span="12">
                <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属场站：" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属设备：" :label-width="formLabelWidth" prop="pileName">
                  <label v-text="detailForm.pileName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="桩类型：" :label-width="formLabelWidth" prop="pileTypeName">
                  <label v-text="detailForm.pileTypeName"></label>
                </el-form-item>
              </el-col>
              <!--<el-col :span="12">
                <el-form-item label="二级运营商：" :label-width="formLabelWidth" prop="virtualId">
                  <label v-text="detailForm.virtualId"></label>
                </el-form-item>
              </el-col>-->
            </el-collapse-item>
            <el-collapse-item title="充电状态信息" name="chargingStatusInformation">
              <el-col :span="12">
                <el-form-item label="状态：" :label-width="formLabelWidth" prop="state">
                  <label v-if="detailForm.state" v-text="detailForm.state.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="枪连接状态：" :label-width="formLabelWidth" prop="gunConnectionState">
                  <label v-if="detailForm.gunConnectionState"
                         v-text="detailForm.gunConnectionState.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电压：" :label-width="formLabelWidth" prop="voltage">
                  <label v-text="detailForm.voltage"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电流：" :label-width="formLabelWidth" prop="current">
                  <label v-text="detailForm.current"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="功率：" :label-width="formLabelWidth" prop="power">
                  <label v-text="detailForm.power"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电量：" :label-width="formLabelWidth" prop="quantity">
                  <label v-text="detailForm.quantity"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="soc：" :label-width="formLabelWidth" prop="soc">
                  <label v-text="detailForm.soc"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="启动充电信息" name="chargingStartInformation">
              <el-col :span="12">
                <el-form-item label="启动方式：" :label-width="formLabelWidth" prop="startType">
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==0">刷卡启动</label>
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==1">扫码启动</label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="卡号/手机号：" :label-width="formLabelWidth" prop="startNum">
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==0" v-text="detailForm.cardNo"></label>
                  <label v-if="detailForm.stateCode==2&&detailForm.startType ==1" v-text="detailForm.phone"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启动时间：" :label-width="formLabelWidth" prop="startTime">
                  <label v-if="detailForm.stateCode==2" v-text="detailForm.startTime"></label>
                </el-form-item>
              </el-col>
<!--              <el-col :span="12">-->
<!--                <el-form-item label="充电策略：" :label-width="formLabelWidth" prop="chargingType">-->
<!--                  <label v-text="detailForm.chargingType"></label>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
            </el-collapse-item>
            <el-collapse-item title="BMS信息" name="BMSInformation">
              <el-col :span="12">
                <el-form-item label="bms电压：" :label-width="formLabelWidth" prop="bmsVoltage">
                  <label v-text="detailForm.bmsVoltage"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="bms电流：" :label-width="formLabelWidth" prop="bmsCurrent">
                  <label v-text="detailForm.bmsCurrent"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="bms模式：" :label-width="formLabelWidth" prop="bmsPattern">
                  <label v-text="detailForm.bmsPattern"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
      <!--          <el-tab-pane label="充电记录" name="chargingRecord"></el-tab-pane>-->
      <!--          <el-tab-pane label="充电报文" name="chargingMessage"></el-tab-pane>-->
    </el-tabs>
  </el-dialog>
</template>

<script>
  export default {
    name: "detail",
    data(){
      return{
        viewName: 'detailForm',
        activeNames: ['basicInformation'],
        formLabelWidth: '150px',
      }
    },
    props:{
      detailFormVisible:false,
      detailForm: {},
    },
    methods:{
      closeDetailForm(){
        this.$emit("closeDetailForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager/detail.vue